import 'css-chunksrc/client/pages/projectPage/kanbanPage/toolbar/filter/styles.scss';export default {
  "filter": "_filter_a6qpz_1",
  "rootClassName": "_rootClassName_a6qpz_10",
  "listRoot": "_listRoot_a6qpz_14",
  "list": "_list_a6qpz_14"
};